import '@/assets/css/reset.css'
import '@/assets/css/style.css'
import '@/assets/css/index.css'
import '@/assets/css/notify.css'
import '@/assets/css/fonts.css'
// 品牌主 CTA 按钮（.db-cta）全站唯一实现，必须排在 index.css（→ main.css）之后
import '@/assets/css/brandCta.css'
import { createRouter } from '@/router'
import VueLazyload from 'vue-lazyload';

import { createApp } from 'vue'
import pinia from '@/stores/index.js'

import App from '@/App.vue'

const app = createApp(App)

const router = createRouter()
app.use(pinia)
app.use(router)
// 只保留真正生效的配置：loading / error 原本指向不存在的
// 'path/to/loading.gif'、'path/to/error.png'，占位图从来没能显示过，
// 反而会在图片未加载时触发一次 404 请求，故去掉这两个键。
app.use(VueLazyload, {
  preLoad: 1.3, // 预加载高度比例
  attempt: 1, // 尝试次数
});
app.mount('#app')
